import React from 'react'
import { VStack, Text } from '@chakra-ui/react'
import Icon from 'components/Icon'

const PaymentSuccessful = () => {
  return (
    <VStack
      maxWidth={{ base: 'full', md: '500px' }}
      marginX="auto"
      minHeight={{ base: 'full', lg: 'auto' }}
      spacing={{ base: 6, lg: 8 }}
      paddingX={4}
    >
      <Icon iconName="payment_successful.svg" size={64} />
      <Text
        textAlign="center"
        fontWeight="500"
        textColor="gray.700"
        lineHeight={6}
        width="full"
        alignSelf="center"
        marginX={4}
      >
        Your payment method information was successfully updated.
      </Text>
    </VStack>
  )
}

export default PaymentSuccessful
